/* How to write stories: https://storybook.js.org/docs/formats/component-story-format/ */
import React from "react";
import LogOutDialog from "./LogOutDialog.js";
import IdleTimer from "./IdelTime";
import { View } from "react-native";
var PnmacSessionTimer = function (props) {
  var _a = React.useState(false),
    showTimeOut = _a[0],
    setShowTimeOut = _a[1];
  var _b = React.useState(),
    timer = _b[0],
    setTimer = _b[1];
  var _c = React.useState(parseInt(props.timeoutint)),
    time = _c[0],
    setTime = _c[1];
  var _d = React.useState(1),
    key = _d[0],
    setKey = _d[1];
  var handleOnIdle = function (event) {
    if (timer == null) {
      var ti = setInterval(function () {
        if (time <= 0) {
          if (props.handleOnIdle) {
            props.handleOnIdle();
          }
        }
        if (time >= 1) {
          setTime(time = time - 1);
        }
      }, 1000);
      setTimer(ti);
    }
    setShowTimeOut(true);
    props === null || props === void 0 ? void 0 : props.userIdleDetected(true);
  };
  var closeModal = function (logout) {
    setKey(key + 1);
    clearInterval(timer);
    setTimer(null);
    setTime(parseInt(props.timeoutint));
    if (props.closeCallBack) {
      props.closeCallBack();
    }
    setShowTimeOut(false);
    props === null || props === void 0 ? void 0 : props.userIdleDetected(false);
  };
  return /*#__PURE__*/React.createElement(View, {
    key: key
  }, /*#__PURE__*/React.createElement(IdleTimer, {
    throttle: props.throttle,
    timeout: props.timeOutTime,
    onIdle: handleOnIdle,
    onAction: props.onAction,
    onActive: props.onActive
  }), /*#__PURE__*/React.createElement(LogOutDialog, {
    timer: time,
    message: "".concat(props.message),
    keepMeLoggedIn: props.keepMeLoggedIn,
    title: props.title,
    close: closeModal,
    open: showTimeOut
  }));
};
export default PnmacSessionTimer;